import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import {
  CareFakedoorSteps,
  CareFakedoorModalProps,
} from './CareFakedoorModal.types'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useRequestFakedoorInsights } from '../../queries/useRequestFakedoorInsights'
import { useState } from 'react'
import { toast } from '@conexasaude/conexa-hero'
import { CareTrackers } from '../../types'
import { CARE_FAKEDOOR_MODAL_TEXTS } from './CareFakedoorModal.constants'

export const useCareFakedoorModal = (props: CareFakedoorModalProps) => {
  const { closeModal } = useModalContext()
  const { logAnalyticsEvent } = useFirebaseContext()
  const { mutate: requestFakeDoorInsights } = useRequestFakedoorInsights()

  const [step, setStep] = useState(0)
  const [textAreaValue, setTextAreaValue] = useState('')

  const notifyUser = () => {
    requestFakeDoorInsights(
      {
        type: props.type,
      },
      {
        onSuccess: () => {
          nextStep()
        },
        onError: () => {
          toast({
            variant: 'error',
            message: CARE_FAKEDOOR_MODAL_TEXTS.errors.notification,
          })
        },
      },
    )
  }

  const requestNotification = () => {
    requestFakeDoorInsights(
      {
        type: props.type,
        comment: textAreaValue,
      },
      {
        onSuccess: () => {
          nextStep()
        },
        onError: () => {
          toast({
            variant: 'error',
            message: CARE_FAKEDOOR_MODAL_TEXTS.errors.feedback,
          })
        },
      },
    )
  }

  const STEPS = [
    {
      step: CareFakedoorSteps.UNAVAILABLE_FEATURE,
      title: CARE_FAKEDOOR_MODAL_TEXTS.unavailableFeature.title,
      primaryActionLabel:
        CARE_FAKEDOOR_MODAL_TEXTS.unavailableFeature.actions.primary,
      primaryAction: notifyUser,
      negativeActionLabel:
        CARE_FAKEDOOR_MODAL_TEXTS.unavailableFeature.actions.negative,
      nextStep: CareFakedoorSteps.SEND_FEEDBACK,
      primaryTracker: CareTrackers.CareFakedoorModalNotifyUserYes,
      negativeTracker: CareTrackers.CareFakedoorModalNotifyUserNo,
    },
    {
      step: CareFakedoorSteps.SEND_FEEDBACK,
      title: CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.title,
      primaryActionLabel:
        CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.actions.primary,
      primaryAction: requestNotification,
      negativeActionLabel:
        CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.actions.negative,
      nextStep: CareFakedoorSteps.SENDED_FEEDBACK,
      primaryTracker: CareTrackers.CareFakedoorModalFeedbackYes,
      primaryTrackerParams: {
        texto_feedback: textAreaValue.slice(0, 100),
      },
      negativeTracker: CareTrackers.CareFakedoorModalFeedbackNo,
    },
    {
      step: CareFakedoorSteps.SENDED_FEEDBACK,
      title: CARE_FAKEDOOR_MODAL_TEXTS.sendedFeedback.title,
      primaryActionLabel: null,
      negativeActionLabel:
        CARE_FAKEDOOR_MODAL_TEXTS.sendedFeedback.actions.negative,
      nextStep: null,
      primaryTracker: CareTrackers.CareFakedoorModalFinish,
      negativeTracker: CareTrackers.CareFakedoorModalFinish,
    },
  ]

  const close = () => {
    logAnalyticsEvent(STEPS[step].negativeTracker)
    setStep(0)
    setTextAreaValue('')
    closeModal()
  }

  const nextStep = () => {
    if (STEPS[step].nextStep) {
      setStep(STEPS[step].nextStep)
    }

    logAnalyticsEvent(
      STEPS[step].primaryTracker,
      STEPS[step].primaryTrackerParams
        ? STEPS[step].primaryTrackerParams
        : undefined,
    )
  }

  return {
    step,
    STEPS,
    close,
    nextStep,
    notifyUser,
    textAreaValue,
    setTextAreaValue,
    requestNotification,
  }
}
